import { createContext, useContext } from 'react';
import type { Route } from './routes';

export interface RouterValue {
  readonly route: Route;
  readonly pathname: string;
  readonly search: string;
  /** True while the outgoing page fades before the URL changes. */
  readonly exiting: boolean;
  /**
   * True while the location is being handed to a document the SPA does not render: a signed-out
   * visitor on the vault route (sent to the intake) or /shadow-oracle (FN-D14).
   */
  readonly redirecting: boolean;
  navigate: (url: string) => void;
}

export const RouterContext = createContext<RouterValue | null>(null);

export function useRouter(): RouterValue {
  const value = useContext(RouterContext);
  if (value === null) throw new Error('useRouter must be used within RouterProvider');
  return value;
}
